import { formatDateWithLocale, getPeriodTypeNameWithLocale, getDayOfWeekName, isStringDate, } from './date.js';
import { formatNumberWithLocale } from './number.js';
import { defaultLocale } from './locale.js';
import { PeriodType, DayOfWeek } from './date_types.js';
export function format(value, format, options) {
    return formatWithLocale(defaultLocale, value, format, options);
}
export function formatWithLocale(settings, value, format, options) {
    if (typeof format === 'function') {
        return format(value);
    }
    else if (value instanceof Date || isStringDate(value) || (format && format in PeriodType)) {
        return formatDateWithLocale(settings, value, (format ?? PeriodType.Day), options);
    }
    else if (typeof value === 'number') {
        return formatNumberWithLocale(settings, value, format, options);
    }
    else if (typeof value === 'string') {
        // Keep original value if already string
        return value;
    }
    else if (value == null) {
        return '';
    }
    else {
        // Provide some reasonable fallback for objects/etc (maybe use stringify() instead)
        return `${value}`;
    }
}
export function buildFormatters(settings) {
    const mainFormat = (value, style, options) => formatWithLocale(settings, value, style, options);
    mainFormat.settings = settings;
    mainFormat.getDayOfWeekName = (day) => getDayOfWeekName(day, settings.locale);
    mainFormat.getPeriodTypeName = (period) => getPeriodTypeNameWithLocale(settings, period);
    return mainFormat;
}
